import { scopes } from "./scripts-scopes-screen.js";

export default {
	scopes
}